var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataStatistic"},[_c('div',{staticClass:"item",attrs:{"id":'main-GZ' + _vm.id}}),_c('div',{staticClass:"item",attrs:{"id":'main-QC' + _vm.id}}),_c('div',{staticClass:"item",attrs:{"id":'main-XX'+ _vm.id}}),_c('div',{staticClass:"item",attrs:{"id":'main-LX'+ _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }